import * as APIModels from "../../models";
const never = "never" as const;
const bool = "boolean" as const;

import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { Column } from "@material-table/core";

dayjs.extend(utc);
dayjs.extend(timezone);

const MergedTemplateColumns: Array<Column<APIModels.FileInfo>> = [
    {
        title: "File Name",
        field: "filename",
        editable: never,
    },
    {
        title: "Date Modified",
        field: "lastUpdatedDateTime",
        editable: never,
        defaultSort: "desc",
        render: (obj) => (
            <span>
                {dayjs(obj.lastUpdatedDateTime).format("YYYY-MM-DD hh:mm")}
            </span>
        ),
    },
    {
        title: "Size",
        field: "size",
        editable: never,
    },
];

const MattersColumns = [
    {
        title: "Matter Number",
        field: "matterNumber",
        editable: never,
    },
    {
        title: "Case Title",
        field: "caseTitle",
    },
    {
        title: "Court Case #",
        field: "courtCaseNumber",
        editable: never,
    },
    {
        title: "County",
        field: "county",
    },
    {
        title: "Case Status",
        field: "caseStatus",
    },
];

export { MergedTemplateColumns, MattersColumns };
